export default __webpack_public_path__ + "ce918fd984b85cebf8b96530c8386d04.woff";